import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const AttachmentIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.68 1.40976C13.8 0.46992 12.63 0 11.46 0C10.31 0 9.15 0.46992 8.27 1.40976L0.95 9.22752C0.32 9.90036 0 10.7868 0 11.6626C0 12.5383 0.31 13.4354 0.95 14.1083C1.57 14.7704 2.4 15.1015 3.23 15.1015C4.06 15.1015 4.89 14.7704 5.53 14.0869L12.84 6.26916C13.6 5.4468 13.6 4.15452 12.85 3.35352C12.1 2.55252 10.86 2.54184 10.1 3.35352L4.03 9.84696C3.79 10.114 3.79 10.5412 4.04 10.8082C4.29 11.0752 4.69 11.0752 4.95 10.8188L11.02 4.3254C11.27 4.0584 11.69 4.0584 11.93 4.31472C12.18 4.58172 12.18 5.03028 11.93 5.29728L4.62 13.115C3.87 13.916 2.58 13.9054 1.86 13.1257C1.11 12.3247 1.13 10.9684 1.87 10.178L9.2 2.37096C10.44 1.04664 12.55 1.02528 13.78 2.33892C15.02 3.66324 15.02 5.9274 13.78 7.25172L6.66 14.8666C6.42 15.1336 6.42 15.5501 6.67 15.8064C6.91 16.0627 7.3 16.0627 7.55 15.8171V15.8278L14.68 8.21292C15.56 7.29444 16 6.06624 16 4.82736C16 3.58848 15.56 2.3496 14.68 1.40976Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default AttachmentIcon;
